import styled from 'styled-components';

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 3px;
  margin-bottom: 8px !important;

  > div:first-child {
    font-size: 14px;
    color: #454545;
  }
  > div:last-child {
    font-size: 16px;
    color: #080808;
    font-weight: 600;
  }
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  color: #080808;
  font-weight: 600;
`;
